import { DropDownList, DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { FC, useCallback } from 'react';
import usePeriodView from 'src/hooks/usePeriodView';
import { SetState } from 'src/types/generic';
import { fiscalYearType } from './Export';

interface FiscalYearDropdownProps {
  fiscalYear: fiscalYearType | null;
  setFiscalYear: SetState<fiscalYearType | null>;
  disabled?: boolean;
  data: fiscalYearType[];
  loading?: boolean;
}
const FiscalYearDropdown: FC<FiscalYearDropdownProps> = ({
  fiscalYear,
  setFiscalYear,
  disabled,
  data,
  loading,
}) => {
  const { t } = usePeriodView();

  const handleFiscalYearChange = useCallback(
    (event: DropDownListChangeEvent) => {
      setFiscalYear(event.value);
    },
    [setFiscalYear]
  );

  return (
    <div className="mb-2">
      <label className="text-xs font-bold">{t('Fiscal Year')}</label>
      <DropDownList
        id="view-drop-down-list"
        style={{ width: '100%' }}
        data={data}
        textField="content"
        dataItemKey="content"
        value={fiscalYear}
        onChange={handleFiscalYearChange}
        disabled={disabled}
        loading={loading}
      />
    </div>
  );
};

export default FiscalYearDropdown;
